import { ReassignUserReducerState } from "../types";

export const reassignUserState: ReassignUserReducerState = {
    reassignRow: [],
    trackingRow: [],
    userToReassignId: null,
    loadings: {
        reassignTable: false,
        trackingTable: false,
        trackingSave: false,
        reassignSave: false,
    },
    trackingData: {
        usersToTracking: [],
        bossCanFollowUp: false,
    },
    items: {
        area: [],
        department: [],
        division: [],
        role: [],
        store: [],
        userType: [],
    }
} 